import BlockLoader from "@/Components/Loaders/BlockLoader";
import { useDuplicateOrderForm } from "@/entities/new-order";
import { CreateOrderForm } from "@/widgets/create-order-form";
import { FormProvider } from "react-hook-form";

export const DuplicateOrder = () => {
  const { methods, handleReset, isLoading } = useDuplicateOrderForm();

  return (
    <FormProvider {...methods}>
      <CreateOrderForm handleReset={handleReset} />
      {isLoading ? <BlockLoader size="lg" /> : null}
    </FormProvider>
  );
};
